<template>
  <div style="display: flex">
    <!-- 第一级 -->
    <el-select v-model="selected.level1" placeholder="请选择一级" @change="handleLevel1Change" clearable style="width: 200px; margin-right: 10px">
      <el-option v-for="item in options.level1" :key="item.val" :label="item.text" :value="item.val"></el-option>
    </el-select>

    <!-- 第二级 -->
    <el-select v-model="selected.level2" placeholder="请选择二级" @change="handleLevel2Change" clearable style="width: 200px; margin-right: 10px" :disabled="!options.level2.length">
      <el-option v-for="item in options.level2" :key="item.val" :label="item.text" :value="item.val"></el-option>
    </el-select>

    <!-- 第三级 -->
    <el-select v-model="selected.level3" placeholder="请选择三级" clearable style="width: 200px" :disabled="!options.level3.length">
      <el-option v-for="item in options.level3" :key="item.val" :label="item.text" :value="item.val"></el-option>
    </el-select>
  </div>
</template>

<script>
import { getAddress } from '@/api/index';
import { encrypt, decrypt } from '@/api/common_encrypt';

export default {
  props: {
    address: {
      type: Array,
      default: () => [],
    },
  },
  watch: {
    address(newval, oldVal) {
      this.init();
    },
  },
  data() {
    return {
      selected: {
        level1: null, // 一级选中值
        level2: null, // 二级选中值
        level3: null, // 三级选中值
      },
      options: {
        level1: [], // 一级选项
        level2: [], // 二级选项
        level3: [], // 三级选项
      },
      _address: [], // 默认选中值
    };
  },
  mounted() {
    // this.inti()
    this.init();
  },
  methods: {
    init() {
      this.loadLevel1(); // 加载第一级数据
      this._address = JSON.parse(JSON.stringify(this.address));
      // // 如果有默认值，依次加载二级和三级数据
      if (this._address && this._address.length > 0) {
        this.selected.level1 = this._address[0];
        this.loadLevel2(this._address[0]).then(() => {
          this.selected.level2 = this._address[1];
          this.loadLevel3(this._address[1]).then(() => {
            this.selected.level3 = this._address[2];
          });
        });
      }
    },
    // 模拟加载第一级数据
    loadLevel1() {
      let info = {
        father: '',
        type: 1,
      };
      return getAddress(encrypt(JSON.stringify(info))).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('getAddress :>> ', info, ress);
          this.options.level1 = ress;
        }
      });
    },
    // 模拟加载第二级数据
    loadLevel2(parentId) {
      let info = {
        father: parentId || this.selected.level1,
        type: 2,
      };
      return getAddress(encrypt(JSON.stringify(info))).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('getAddress :>> ', info, ress);
          this.options.level2 = ress;
        }
      });
    },
    // 模拟加载第三级数据
    loadLevel3(parentId) {
      let info = {
        father: parentId || this.selected.level2,
        type: 3,
      };
      return getAddress(encrypt(JSON.stringify(info))).then((res) => {
        if (res.result == 1) {
          var ress = JSON.parse(decrypt(res.data));
          console.log('getAddress :>> ', info, ress);
          this.options.level3 = ress;
        }
      });
    },
    // 处理第一级改变
    handleLevel1Change(value) {
      this.selected.level2 = null; // 清空二级选择
      this.selected.level3 = null; // 清空三级选择
      this.options.level3 = []; // 清空三级选项
      this.loadLevel2(value); // 加载二级数据
    },
    // 处理第二级改变
    handleLevel2Change(value) {
      this.selected.level3 = null; // 清空三级选择
      this.loadLevel3(value); // 加载三级数据
    },

    getAddress() {
      let address = {
        province: {
          val: null,
          text: null,
        },
        city: {
          val: null,
          text: null,
        },
        country: {
          val: null,
          text: null,
        },
      };

      console.log('this.selected :>> ', this.selected);

      if (this.selected.level1) {
        address.province = this.options.level1.find((item) => item.val == this.selected.level1);
      }
      if (this.selected.level2) {
        address.city = this.options.level2.find((item) => item.val == this.selected.level2);
      }
      if (this.selected.level3) {
        address.country = this.options.level3.find((item) => item.val == this.selected.level3);
      }

      return address;
    },
  },
};
</script>

<style scoped>
.el-select {
  width: 200px;
}
</style>
